import React from 'react';
import { Tag } from 'antd';

export default function SelfSetting({ t, selfSettingTags = [], setSelfSettingTags = () => {} }) {
  const handleSelectTag = (id, type) => {
    const updateTags = [...selfSettingTags];
    updateTags.forEach(tag => {
      if (tag.id === id) {
        tag.checked = type === 'delete' ? false : true;
      }
    });
    setSelfSettingTags(updateTags);
  };

  const checkedTags = selfSettingTags.filter(tag => tag.checked);

  return (
    <div className="self-setting-wrapper">
      <p className="property-detail__subtitle">
        {t('cms.property_detail.tag.self_setting.subtitle')}
      </p>
      <div className="selected-setting-tags">
        {checkedTags.length > 0 ? (
          selfSettingTags.map((tag, index) => (
            <If condition={tag.checked}>
              <Tag
                style={{ color: '#6B92F3' }}
                key={index}
                closable
                onClick={() => handleSelectTag(tag.id, 'delete')}
              >
                {tag.name}
              </Tag>
            </If>
          ))
        ) : (
          <p className="empty-tags-tip">
            {t('cms.property_detail.tag.self_setting.describe_empty_tag')}
          </p>
        )}
      </div>

      <If condition={checkedTags.length !== selfSettingTags.length}>
        <div className="choose-setting-tags">
          <p className="describe-tip">{t('cms.property_detail.tag.self_setting.describe_tag')}</p>
          <div className="selected-setting-tags">
            {selfSettingTags.map((tag, index) => (
              <If condition={!tag.checked}>
                <Tag key={index} onClick={() => handleSelectTag(tag.id)}>
                  {tag.name}
                </Tag>
              </If>
            ))}
          </div>
        </div>
      </If>
    </div>
  );
}
